import { render } from "./LiteratureSearchOverview.vue?vue&type=template&id=4f5c62c9"
import script from "./LiteratureSearchOverview.vue?vue&type=script&lang=js"
export * from "./LiteratureSearchOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__